import React from "react";

const EMPTY = <span>&nbsp;</span>;

export default EMPTY;
